import { BiEventData, reportBiEvent, ReportBiEventParams } from '@fiverr-private/store_builder_bi_events';
import { ElementType } from '@fiverr-private/bianka_js';
import { Niche } from '@fiverr-private/store_builder_types';

export const reportNicheCardLinkClick = ({
    biEventData,
    pageName,
    chosenNiche,
}: {
    biEventData: BiEventData;
    pageName: string;
    chosenNiche: Niche;
}) => {
    const reportParams: ReportBiEventParams = {
        biEventData,
        activityType: 'click',
        eventType: 'clicked_on_bys_niche_card',
        elementName: 'bys_niche_card',
        elementType: ElementType.LINK,
        pageName,
        store: {
            niche: chosenNiche,
        },
    };

    reportBiEvent(reportParams);
};
